import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import './LoginPage.css'
import { RxCross1 } from "react-icons/rx";
import {signIn} from '../axios'

function LoginPage() {

  const [loginInput, setloginInput] = useState('');
  const [otpValue, setotpValue] = useState('')

  const handleLoginValue = (e) => {
    setloginInput(e.target.value);
    console.log(loginInput);
  }

  const handleOtpValue = (e)=>{
    setotpValue(e.target.value);
  }

  const handleLogin =async()=>{
    const browserToken =  localStorage.getItem('browsertoken');
    const user = await signIn(loginInput,browserToken);
    console.log(user);
    debugger
document.getElementById('login_page').classList.add('hidden');
document.getElementById('otp_page').classList.remove('hidden');
  }

  const handleOtpVerification = async()=>{
console.log(otpValue);
  }

  const handleCancel = () => {
    document.getElementsByClassName('login_ui')[0].classList.add('hidden');
    document.getElementById('root').classList.remove('black_background')
    document.getElementById('root').classList.remove('black_background_position');
      let listOfwhitearea = document.getElementsByClassName('gender')
      for (let i = 0; i < listOfwhitearea.length; i++) {
        listOfwhitearea[i].classList.remove('black_background')
      }

  }

  useEffect(() => {
    document.getElementById('root').classList.remove('black_background');

  }, [])

  return (
    <>
    <div className='login_page' id='login_page'>
      <div className='cross' onClick={handleCancel}>
        <RxCross1 className='cancel' />
      </div>
      <div className='login'>
        <p className='login_heading'>Login / Sign Up</p>
        <p className='sub_heading'>We do not share your personal details with anyone.</p>
      </div>
      <div className='email_input'>
        <input value={loginInput} placeholder='Email/Phone No' onChange={(e) => handleLoginValue(e)} />
        <div className='login_btn'>
          <p onClick={handleLogin}>PROCESSED</p>
        </div>
      </div>
    </div>
    <div className='login_page hidden' id='otp_page'>
      <div className='cross' onClick={handleCancel}>
        <RxCross1 className='cancel' />
      </div>
      <div className='login'>
        <p className='login_heading'>OTP Verification</p>
        <p className='sub_heading'>Please enter your OTP to processed further</p>
      </div>
      <div className='otp_input'>
      <OtpInput
      value={otpValue}
      onChange={setotpValue}
      numInputs={4}
      renderSeparator={<span>-</span>}
      renderInput={(props) => <input {...props} />}
    />  
        {/* <input value={otpValue} placeholder='Email/Phone No' onChange={(e) => handleOtpValue(e)} /> */}
        <div className='otp_btn'>
          <p onClick={handleOtpVerification}>VERIFY</p>
        </div>
      </div>
    </div>
    </>
  )
}

export default LoginPage